export default __webpack_public_path__ + "static/media/short.7b9721bf.mp3";